import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import { useOnClickOutside } from "../../hooks";
import { useSelector } from "react-redux";

import * as S from "./styled";

import logo from "../../assets/logo-mobile.svg";
import Burger from "../Burguer";
import Profile from "../Profile";

const Header = () => {
  const [open, setOpen] = useState(false);
  const node = useRef();
  useOnClickOutside(node, () => setOpen(false));

  const profile = useSelector((state) => state.user?.profile);

  return (
    <S.Container>
      <Link to="/dashboard">
        <S.Logo src={logo} alt="Peixe Solidário" />
      </Link>

      <Burger open={open} setOpen={setOpen} />
      <Profile
        open={open}
        setOpen={setOpen}
        username={profile?.name}
        usercpf={profile?.cpf}
      />
    </S.Container>
  );
};

export default Header;
